import {
  InputTextMaster,
  InputCheckboxMaster,
  Modal,
  InputTextArea,
  MasterButton,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  instance2,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import React, { useState, useEffect } from "react";
import RenderCaseRootAndFuncAddViaChild from "./RenderCaseAndFuncAddViaChild";
import RenderCaseRootAndFuncEdit from "./RenderCaseRootAndFuncEdit";
import RenderCaseRootAndFuncAddParent from "./RenderCaseRootAndFuncAddParent";
import { Grid } from "@material-ui/core";

const RenderCaseRootAndFunc = ({ formData, setFormData }) => {
  if (formData.add_on_parent === 1) {
    return (
      <RenderCaseRootAndFuncAddParent
        formData={formData}
        setFormData={setFormData}
      />
    );
  }

  if (formData.edit === 1) {
    return (
      <RenderCaseRootAndFuncEdit
        formData={formData}
        setFormData={setFormData}
      />
    );
  }

  if (formData.add_on_child === 1) {
    return (
      <RenderCaseRootAndFuncAddViaChild
        formData={formData}
        setFormData={setFormData}
      />
    );
  }

  return <div>RENDER CASE ROOT AND FUNC</div>;
};

const ModalForm = ({ setShowModal, formData, setFormData, run }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addmenu = async () => {
    return instance2.post("/menumanagement/addmenu", {
      code: formData.code,
      icon: formData.icon,
      is_function: formData.is_function,
      is_root: formData.is_root,
      name: formData.name,
      parent_code: formData.parent_code,
      seq: formData.seq,
      status: formData.status ? 1 : 0,
    });
  };

  const updatemenu = () => {
    return instance2.post(
      "/menumanagement/updatemenu",
      {
        code: formData.code,
        icon: formData.icon,
        is_function: formData.is_function,
        is_root: formData.is_root,
        name: formData.name,
        parent_code: formData.parent_code,
        seq: formData.seq,
        status: formData.status ? 1 : 0,
      },
      {
        headers: {
          idmenu: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "" || formData.code === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama dan Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addmenu();
          defaultToastSuccess("Berhasil menambah menu");
        } else {
          await updatemenu();
          defaultToastSuccess("Berhasil mengubah menu");
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
        run(!run);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  useEffect(() => {
    if (formData.add_on_parent !== 1) {
      if (
        (formData.is_root_parent === 0 || formData.is_root_parent === false) &&
        (formData.is_func_parent === 0 || formData.is_func_parent === false)
      ) {
        setFormData({
          ...formData,
          is_function: 1,
        });
      }
    }

    if (formData.is_root) {
      setFormData({
        ...formData,
        is_root_func: "1",
      });
    }

    if (formData.is_function) {
      setFormData({
        ...formData,
        is_root_func: "2",
      });
    }

    if (formData.is_function === false && formData.is_root === false) {
      setFormData({
        ...formData,
        is_root_func: "3",
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      title={`${formData.id === "" ? "Tambah Menu" : "Update Menu"}`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='code'
              label='KODE'
              id='code'
              value={formData.code}
              disabled={formData.id !== "" ? true : false}
              onChange={handleChange("code")}
              placeholder='Kode'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='NAMA'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='NAMA'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='icon'
              label='ICON'
              id='icon'
              value={formData.icon}
              onChange={handleChange("icon")}
              placeholder='Icon'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='parent_code'
              label='PARENT CODE'
              id='parent_code'
              disabled={true}
              value={formData.parent_code}
              onChange={handleChange("parent_code")}
              placeholder='Parent Code'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='seq'
              label='SEQUENCE'
              id='seq'
              value={formData.seq}
              onChange={handleChange("seq")}
              placeholder='Sequence'
            />
          </Grid>

          <RenderCaseRootAndFunc
            formData={formData}
            setFormData={setFormData}
          />

          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.status}
              name='status'
              id='status'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, status: !formData.status })
              }
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextArea
              label={"Catatan"}
              placeholder={"Catatan"}
              name='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              id='remark'
              rows={"3"}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};

export default ModalForm;
